import { InspectorDTO } from 'src/types/dto';

/** Passthrough wrapper kept for a stable import site in the allocation grid. */
export const InspectorTooltip = ({
  children,
}: {
  inspector: InspectorDTO;
  children: React.ReactElement;
}) => children;
